import React, { useState } from 'react';
import { generateIdenticon, identiconToSvg } from '@/Data/Identicon';

interface FastAvatarProps {
    uri?: string | null;
    userid: string;
    size: number;
    style?: React.CSSProperties;
    className?: string;
}

export const FastAvatar: React.FC<FastAvatarProps> = ({ 
    uri, 
    userid, 
    size, 
    style,
    className
}) => {
    const [imageError, setImageError] = useState(false);
    const [imageLoading, setImageLoading] = useState(true);
    
    // Determine if circular based on borderRadius
    const borderRadius = style?.borderRadius;
    const isCircular = borderRadius === '50%' || (typeof borderRadius === 'number' && borderRadius >= size / 2);
    
    // Generate identicon for fallback
    const identicon = React.useMemo(() => {
        const data = generateIdenticon(userid);
        const svg = identiconToSvg(data, size, isCircular);
        return `data:image/svg+xml,${encodeURIComponent(svg)}`;
    }, [userid, size, isCircular]);
    
    if (!uri || imageError) {
        return (
            <img 
                src={identicon}
                width={size}
                height={size}
                style={{
                    display: 'block',
                    ...style
                }}
                alt=""
            />
        );
    }
    
    return (
        <div style={{ position: 'relative', width: size, height: size, ...style }} className={className}>
            {imageLoading && (
                <div 
                    style={{
                        position: 'absolute',
                        width: size,
                        height: size,
                        backgroundColor: '#c0c0c0',
                        ...style
                    }}
                />
            )}
            <img
                src={uri}
                width={size}
                height={size}
                style={{
                    display: 'block',
                    objectFit: 'cover',
                    ...style
                }}
                onError={() => setImageError(true)}
                onLoad={() => setImageLoading(false)}
                alt=""
            />
        </div>
    );
};